export default __webpack_public_path__ + "static/media/navBarLogo.4d7d9938.svg";